import { configureStore } from "@reduxjs/toolkit";
import loggedInUserReducer from './slices/logged_in_user';
import headerReducer from './slices/header';

export const store = configureStore({
  reducer: {
    loggedInUser: loggedInUserReducer,
    header: headerReducer
  }
})